const routes = [
    {
        path: '/acquiring',
        name: 'Acquiring',
        component: () => import('@/views/v2/AcquiringV2.vue')
    },
    {
        path: '/payout',
        name: 'Payout',
        component: () => import('@/views/v2/PayoutV2.vue')
    },
    {
        path: '/platform',
        name: 'Platform',
        component: () => import('@/views/v2/PlatformV2.vue')
    },
    {
        path: '/integration',
        name: 'Integration',
        component: () => import('@/views/v2/IntegrationV2.vue')
    },
    {
        path: '/card',
        name: 'Card',
        component: () => import('@/views/v2/CardV2.vue')
    },
    {
        path: '/privacy',
        name: 'PrivacyPolicy',
        component: () => import('@/views/v2/PrivacyV2.vue')
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/v2/AboutV2.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('@/views/v2/ContactV2.vue')
    },
    {
        path: '/help',
        name: 'HelpCenter',
        component: () => import('@/views/v2/HelpV2.vue')
    },
    {
        path: '/docs',
        name: 'Docs',
        component: () => import('@/views/v2/DocsV2.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/v2/LoginV2.vue')
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/v2/ContactV2.vue') // Placeholder to contact
    },
    {
        path: '/terms',
        name: 'Terms',
        component: () => import('@/views/v2/TermsV2.vue')
    },
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/v2/HomeV2.vue')
    }
]

export default routes
